export default __webpack_public_path__ + "static/media/25101704.6e9f3b86.jpg";